module.exports = "<select class=\"test-select\">\n\t<slot></slot>\n</select>"